import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server, { uploadServer } from "../../api/server";
import { v4 } from "uuid";
import ReactQuill from "react-quill";

import { Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { Input } from "../../components/shared/FormComponents";
import MetaEditComponent from "./MetaEditComponent";

const MetaPage = ({ match }) => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [currentInfo, setCurrentInfo] = useState({});
	const [sectionsData, setSectionsData] = useState([]);
	const dispatch = useDispatch();

	const {
		params: { aboutUsSectionId },
	} = match;

	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm();

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "اضافة فئة جديدة",
				breadcrumb: "الفئات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		try {
			const initialData = await server(cookie).get(`/pages/metaData/sections`);
			console.log(initialData?.data?.data, "inyyyy");
			const sortOrder = [
				"home",
				"about",
				"services",
				"teamMember",
				"blogs",
				"contact",
				"faqs",
				"hiring",
				"privacy",
				"terms"
			];
			const sortedSections = initialData?.data?.data?.sections
				?.slice()
				?.sort((a, b) => {
					return sortOrder.indexOf(a.slug) - sortOrder.indexOf(b.slug);
				});

			setSectionsData(sortedSections);
		} catch (error) {
			console.log(error);
		}
	};

	// handleMethods
	const submitHandler = async data => {
		setLoading(true);
		try {
			const { picturePath, pictureUrl, ...finalData } = {
				...data,
				title: "metaData",
			};

			const dataResponse = await server(cookie).put(
				`/pages/metaData/sections/`,
				{
					section: finalData,
				}
			);
			toast.success("تم تعديل البيانات بنجاح");

			onStart();
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	// watchers
	useEffect(() => {
		onStart();
	}, []);

	console.log(errors);

	return (
		<section>
			{loading && <Loader />}
			

			{sectionsData?.map((section, index) => {
				return (
					<MetaEditComponent
						key={index}
						title={section?.slug}
						slug={section?.slug}
						data={section}
					/>
				);
			})}
		</section>
	);
};

export default MetaPage;
